import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function hexToRgb(hex) {
  if (!hex) return '37, 99, 235';
  let clean = String(hex).replace('#', '').trim();

  if (clean.length === 3) {
    clean = clean
      .split('')
      .map((char) => char + char)
      .join('');
  }

  const num = parseInt(clean, 16);
  if (Number.isNaN(num)) return '37, 99, 235';

  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;

  return `${r}, ${g}, ${b}`;
}

export default function LandingHero({ settings, content }) {
  const primary = settings?.primary_color || '#0d6efd';
  const secondary = settings?.secondary_color || '#4dabf7';
  const primaryRgb = hexToRgb(primary);
  const secondaryRgb = hexToRgb(secondary);

  const heroPoints = Array.isArray(content?.hero_points) ? content.hero_points.slice(0, 3) : [];

  const heroVars = {
    '--hero-primary': primary,
    '--hero-secondary': secondary,
    '--hero-primary-rgb': primaryRgb,
    '--hero-secondary-rgb': secondaryRgb,
  };

  return (
    <section className="remote-hero" style={heroVars}>
      <div className="remote-hero__bg-shape remote-hero__bg-shape--one" />
      <div className="remote-hero__bg-shape remote-hero__bg-shape--two" />
      <div className="remote-hero__bg-shape remote-hero__bg-shape--three" />
      <div className="remote-hero__dots remote-hero__dots--top" />
      <div className="remote-hero__dots remote-hero__dots--right" />
      <div className="remote-hero__glow remote-hero__glow--one" />
      <div className="remote-hero__glow remote-hero__glow--two" />

      <Container className="remote-hero__container">
        <Row className="align-items-center gy-5">
          <Col lg={5} xl={4}>
            <div className="remote-hero__content">
              {settings?.hero_title ? (
                <h1 className="remote-hero__title">{settings.hero_title}</h1>
              ) : null}

              {settings?.hero_subtitle ? (
                <p className="remote-hero__subtitle">{settings.hero_subtitle}</p>
              ) : null}

              {settings?.hero_cta_text && settings?.hero_cta_url ? (
                <div className="remote-hero__actions">
                  <Button
                    as={Link}
                    to={settings.hero_cta_url}
                    className="remote-hero__cta"
                  >
                    {settings.hero_cta_text}
                  </Button>
                </div>
              ) : null}


            </div>
          </Col>

          <Col lg={7} xl={8}>
            <div className="remote-hero__visual">
              <div className="remote-hero__visual-inner">
                <div className="remote-hero__plane remote-hero__plane--lg" />
                <div className="remote-hero__plane remote-hero__plane--sm" />
                <div className="remote-hero__arc remote-hero__arc--main" />
                <div className="remote-hero__arc remote-hero__arc--soft" />
                <div className="remote-hero__arc remote-hero__arc--bottom" />
                <div className="remote-hero__line remote-hero__line--top" />
                <div className="remote-hero__line remote-hero__line--mid" />
                <div className="remote-hero__line remote-hero__line--bottom" />
                <div className="remote-hero__orbit" />

                <div className="remote-hero__spark remote-hero__spark--1" />
                <div className="remote-hero__spark remote-hero__spark--2" />
                <div className="remote-hero__spark remote-hero__spark--3" />
                <div className="remote-hero__spark remote-hero__spark--4" />
                <div className="remote-hero__spark remote-hero__spark--5" />
                <div className="remote-hero__spark remote-hero__spark--6" />

                {heroPoints[0] ? (
                  <div className="remote-hero__visual-copy remote-hero__visual-copy--one">
                    {heroPoints[0]}
                  </div>
                ) : null}

                {heroPoints[1] ? (
                  <div className="remote-hero__visual-copy remote-hero__visual-copy--two">
                    {heroPoints[1]}
                  </div>
                ) : null}

                {heroPoints[2] ? (
                  <div className="remote-hero__visual-copy remote-hero__visual-copy--three">
                    {heroPoints[2]}
                  </div>
                ) : null}

                <div className="remote-hero__chat remote-hero__chat--back" />
                <div className="remote-hero__chat remote-hero__chat--mid" />
                <div className="remote-hero__chat remote-hero__chat--front" />
                <div className="remote-hero__chat remote-hero__chat--small" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <div className="remote-hero__wave">
        <svg
          viewBox="0 0 1440 170"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 98C89 121 174 132 300 126C454 119 533 83 683 95C845 107 922 150 1114 139C1257 131 1365 109 1440 74V170H0V98Z"
            fill="rgba(255,255,255,0.42)"
          />
          <path
            d="M0 122C120 144 255 147 389 136C529 124 596 96 741 101C902 106 975 149 1133 151C1260 153 1362 132 1440 108V170H0V122Z"
            fill="#f5f7fb"
          />
        </svg>
      </div>
    </section>
  );
}
